import React, { useEffect } from "react";
import styles from "./Login.module.css";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { showAppToast } from "../../Components/Toast/showAppToast";
import { setTokens } from "../../Services/api";
import { PATH } from "../../PATH";
import icon from "../../Assets/google-icon.png";
import { usePermission } from "../../Auth/PermissionContext";

const Login = () => {
  const navigate = useNavigate();
  const { checkAdminPermission } = usePermission();

  const params = new URLSearchParams(window.location.search);
  const access = params.get("access");
  const refresh = params.get("refresh");
  const hasError = params.has("error");

  useEffect(() => {
    if (access && refresh) {
      setTokens(access, refresh);
      checkAdminPermission().then((hasAdmin) => {
        navigate(hasAdmin ? "/status" : "/");
      });
    }
  }, [access, refresh, navigate, checkAdminPermission]);

  useEffect(() => {
    if (hasError) {
      showAppToast("loginError");
    }
  }, [hasError]);

  return (
    <div className={styles.container}>
      <div className={styles.backdrop} aria-hidden />
      <div className={styles.card}>
        <div className={styles.accent} />
        <span className={styles.productName}>Diário Oficial</span>
        <h1 className={styles.title}>Bem-vindo(a)</h1>
        <p className={styles.subtitle}>
          Entre com sua conta Google para acessar o <strong>Diário Oficial</strong>.
        </p>
        <div className={styles.actions}>
          <a
            href={`${PATH.baseApi}/auth/google/`}
            className={styles.google}
          >
            <img
              alt=""
              src={icon}
              className={styles.icon}
              width={22}
              height={22}
            />
            <span className={styles.googleLabel}>Entrar com Google</span>
          </a>
          <Link to="/" className={styles.backLink}>
            <ChevronLeft className={styles.backIcon} aria-hidden />
            Voltar para a página de edições
          </Link>
        </div>
        <p className={styles.footerNote}>
          O acesso é restrito a usuários previamente cadastrados.
        </p>
      </div>
    </div>
  );
};

export default Login;
